// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Text template with optional formattable parameters. Useful to represent in UIs as clickable features like an e-Mail, phone or URL.<br>Usage see for e.g. [`Notice::text`](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/JSON-Objects.md#linkedtext).
 * @export
 * @interface LinkedText
 */
export interface LinkedText {
    /**
     * End-user text.<br>(Translated according to Accept-Language.)<br>If `arguments` are not empty the template must be formatted for end-user readability, by means arguments will be filled in or an UI may make them interactable (for e.g. clickable).
     * @type {string}
     * @memberof LinkedText
     */
    template: string;
    /**
     * Map(key=linkable types {EMAIL,PHONE,URL}, value=list of corresponding linkable values in `LinkedText::template` in ascending order of occurance).
     * @type {{ [key: string]: Array<string>; }}
     * @memberof LinkedText
     */
    arguments: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the LinkedText interface.
 */
export function instanceOfLinkedText(value: object): value is LinkedText {
    if (!('template' in value) || value['template'] === undefined) return false;
    if (!('arguments' in value) || value['arguments'] === undefined) return false;
    return true;
}

export function LinkedTextFromJSON(json: any): LinkedText {
    return LinkedTextFromJSONTyped(json, false);
}

export function LinkedTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkedText {
    if (json == null) {
        return json;
    }
    return {
        
        'template': json['template'],
        'arguments': json['arguments'],
    };
}

  export function LinkedTextToJSON(json: any): LinkedText {
      return LinkedTextToJSONTyped(json, false);
  }

  export function LinkedTextToJSONTyped(value?: LinkedText | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'template': value['template'],
        'arguments': value['arguments'],
    };
}

